import { render, staticRenderFns } from "./configCenter.vue?vue&type=template&id=f838827a&scoped=true"
import script from "./configCenter.vue?vue&type=script&lang=js"
export * from "./configCenter.vue?vue&type=script&lang=js"
import style0 from "./configCenter.vue?vue&type=style&index=0&id=f838827a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f838827a",
  null
  
)

export default component.exports